<div
  class="video-player-placeholder"
  @enterLeaveAnimation
>
  <button class="play-again-button">
    <mat-icon [svgIcon]="'video_hub_replay_icon'">play_arrow</mat-icon>
    Play again
  </button>
</div>
